import { AlertType, classBorderLabelDark, classBt, classInput, classInputDark, classLabel, classLabelDark, classbtAzul, classbtColunasVermelho } from '../../Utils/Types'
import React, { useEffect, useState } from 'react'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { RiEdit2Fill } from 'react-icons/ri'
import { Funcoes } from '../../Utils/Funcoes'

type Props = {
    visible: boolean
    dados: any
    atualizarDadosParcelaCrediario?: (itens: any) => void
    closeModalEvent?: () => void
}

export const ModalEditParcelasCrediario = React.memo(({ visible, dados, atualizarDadosParcelaCrediario, closeModalEvent }: Props) => {

    const [visibleMsg, setVisibleMsg] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    const [loading, setLoading] = useState(false)

    const [item, setItem] = useState(0)
    const [vencimento, setVencimento] = useState('')
    const [valor, setValor] = useState('0')

    useEffect(() => {

        if (visible) {

            getAttributes()

            let modal = document.getElementById('modal_edit_parcela_crediario')
            let modalContent = document.getElementById('modal_content_edit_parcela_crediario')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-500px]')
                    modalContent.classList.add('mt-36')
                }
            }

        } else {

            setVisibleMsg(false)
            setItem(0)
            setVencimento('')
            setValor('0')

            let modal = document.getElementById('modal_edit_parcela_crediario')
            let modalContent = document.getElementById('modal_content_edit_parcela_crediario')

            if (modal) {
                modal.style.visibility = 'hidden'

                if (modalContent) {
                    modalContent.classList.add('mt-[-500px]')
                    modalContent.classList.remove('mt-36')
                }
            }
        }

    }, [visible])

    const getAttributes = async () => {
        setLoading(true)
        try {


            setItem(dados.numDup)
            setVencimento(dados.vencimento)
            setValor(dados.valor.toString())

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível carregar os dados`)

        } finally {
            setLoading(false)
        }
    }

    const vencimentoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setVencimento(e.target.value)
    }

    const valorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValor(Funcoes.MaskMoney(e.target.value))
    }

    const handleCloseMessage = () => {
        setVisibleMsg(false)
    }

    const atualizarParcela = async () => {

        setLoading(true)
        setVisibleMsg(false)

        try {

            // converte datas para comparação
            const hoje = new Date();
            hoje.setHours(0, 0, 0, 0); // zera hora para comparar só a data

            const [ano, mes, dia] = vencimento.split("-").map(Number);
            const dataVencimento = new Date(ano, mes - 1, dia); // meses começam em 0
            dataVencimento.setHours(0, 0, 0, 0);

            // valida se a data é menor que hoje
            if (dataVencimento < hoje) {

                const timer = setTimeout(() => {
                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage("A data de vencimento não pode ser menor que a data atual")
                    clearTimeout(timer)
                }, 250)
                return
            }

            if (vencimento === '') {

                const timer = setTimeout(() => {
                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage("É preciso selecionar uma data para a parcela")
                    clearTimeout(timer)
                }, 250)
                return
            }

            if (parseFloat(valor) <= 0) {

                const timer = setTimeout(() => {
                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage("É preciso selecionar um valor para a parcela")
                    clearTimeout(timer)
                }, 250)
                return
            }

            let itensLista: any = {
                numDup: item,
                vencimento: vencimento,
                valor: valor
            }

            if (atualizarDadosParcelaCrediario) {
                atualizarDadosParcelaCrediario(itensLista || {})
            }


        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Houve um erro ao editar a parcela")

        } finally {

            setLoading(false)

        }
    }

    return (

        <div id="modal_edit_parcela_crediario" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id="modal_content_edit_parcela_crediario" className={`relative flex flex-col w-[90%] md:w-[40%] xl:w-[30%] 2xl:w-[20%] h-[350px] bg-white dark:bg-slate-600 rounded-lg mt-[-500px] transition-all duration-300 justify-center items-center`}>

                <FeedbackMessage visible={visibleMsg} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                <div className={`absolute top-0 w-full h-[70px] flex items-center`}>

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <RiEdit2Fill size={20} className={`w-5 h-5 text-slate-700 dark:text-slate-200`} />
                    </div>

                    <span className={`ml-4 text-lg text-slate-700 dark:text-slate-200 flex items-center font-semibold`}>Editar Parcela</span>
                </div>

                <div className={`absolute top-[70px] w-full`}>

                    <div className={`grid grid-cols-12 gap-4 p-4 w-full`}>

                        <div className={`relative col-span-12`}>
                            <input id="nDupEdit" className={`${classInput} ${classInputDark} cursor-not-allowed`} type="text" placeholder=' ' autoComplete="off" value={item} disabled={true} readOnly />
                            <label htmlFor="nDupEdit" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>N. Dup</label>
                        </div>

                        <div className={`relative col-span-12`}>
                            <input id="vencimentoEdit" className={`${classInput} ${classInputDark} dark:[color-scheme:dark]`} type="date" min="1900-01-01" max="9999-12-31" placeholder=' ' value={vencimento} onChange={vencimentoChange} />
                            <label htmlFor="vencimentoEdit" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Vencimento</label>
                        </div>

                        <div className={`relative col-span-12`}>
                            <input id="valorEdit" className={`${classInput} ${classInputDark}`} type="text" inputMode='numeric' placeholder=' ' autoComplete="off" value={valor} onChange={valorChange} />
                            <label htmlFor="valorEdit" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor</label>
                        </div>

                    </div>

                </div>

                {loading &&

                    <div className={`absolute top-[70px] bottom-[60px] w-full pt-4 bg-slate-300 dark:bg-slate-700 bg-opacity-30 dark:bg-opacity-30 flex justify-center items-center`}>

                        <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                        </div>

                    </div>
                }

                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-start bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-2 rounded-b-lg space-x-3`}>

                    <div className={`flex justify-end items-center w-full space-x-3`}>

                        <button
                            onClick={closeModalEvent} disabled={loading}
                            className={`${classbtColunasVermelho} max-w-[150px]`}>
                            CANCELAR
                        </button>

                        <button
                            onClick={atualizarParcela}
                            className={`${classbtAzul} ${classBt} max-w-[150px] mx-1`}  >
                            {loading &&
                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                </div>
                            }
                            {!loading ? `ATUALIZAR` : `AGUARDE`}

                        </button>

                    </div>

                </div>

            </div>

        </div>

    )
})